// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDynamicFormDefinitionRequestModel from '../../model/get-dynamic-form-definition-request-model';
import GetDynamicFormDefinitionRequestDTO from '../dto/get-dynamic-form-definition-request-dto';

export default abstract class GetDynamicFormDefinitionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDynamicFormDefinitionRequestDTO>) {
    super();
    if (data) {
      this.appSystemKey = data.appSystemKey;
      this.id = data.id;
    }
  }
  /**
  */
  'appSystemKey'?: string;
  /**
  */
  'id'?: string;

  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO>): GetDynamicFormDefinitionRequestModel;
  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO> | undefined | null): GetDynamicFormDefinitionRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO> | undefined | null): GetDynamicFormDefinitionRequestModel | undefined {
    return dto ? new GetDynamicFormDefinitionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDynamicFormDefinitionRequestModel> | GetDynamicFormDefinitionRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'appSystemKey': unwrapped.appSystemKey,
      'id': unwrapped.id,
    } as GetDynamicFormDefinitionRequestDTO;
  }
}
